// Core
import { Map } from 'immutable';
import { handleActions } from 'redux-actions';

// Instruments
import { orderActions as actions } from './actions';

const initialState = Map({
    simple: null,
});

export const orderReducer = handleActions({
    [actions.sendOrder]: (state, { payload: { form }}) => {
        return state.set(form, 'sending');
    },
    [actions.sendOrderSuccess]: (state, { payload: form }) => {
        return state.set(form, 'success');
    },
    [actions.sendOrderFail]: (state, { payload: form }) => {
        return state.set(form, 'fail');
    },
}, initialState);
